import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-actionwithcheckbox',
    template: `
    <input type="checkbox"
       (change)="check($event)"
       style="width: 12px; height: 12px; transform: scale(1.5); margin: 0.5rem; cursor: pointer;" />
    
    
  `,
    standalone: false
})
export class DeleteAndcheckboxComponent implements ICellRendererAngularComp {
  params: any;
  isChecked: boolean = false;
  showDelete: boolean = false;
  showCheckbox: boolean = false;

  agInit(params: any): void {
    this.params = params;
    const data = this.params.data;

    // Customize conditions to decide visibility of Delete button and Checkbox
    console.log(data)
    if ('status' in this.params.data) {
      this.showDelete = true;
      this.showCheckbox = false;
    } else {
      this.showDelete = false;
      this.showCheckbox = true;
    }
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  check($event): void {
    console.log($event)
    console.log(this.params)
    if (this.params.check instanceof Function) {

        const params = {
            event: $event,
            rowData: this.params.node.data
            // ...something
          }
          console.log(params)
          this.params.check(params);
    }        
  }

  delete($event): void {
    if (this.params.delete instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data
      };
      this.params.delete(params);
    }
  }

  edit($event) {
    console.log("----------------")
    console.log($event)
    console.log("-------------------")
    if (this.params.edit instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      this.params.edit(params);

    }
  }
}
